(function () {
  'use strict';
  const observed = new WeakSet();
  function videoUrl(raw, iframe) {
    try {
      const url = new URL(raw, location.href);
      if (!/^(www\.)?youtube(-nocookie)?\.com$/i.test(url.hostname) || !url.pathname.startsWith('/embed/')) return null;
      url.searchParams.set('autoplay', '1');
      url.searchParams.set('mute', '1');
      url.searchParams.set('playsinline', '1');
      url.searchParams.set('enablejsapi', '1');
      if (iframe && iframe.closest('.bls-murano-video-frame')) {
        const videoId = url.pathname.split('/embed/')[1];
        url.searchParams.set('loop', '1');
        if (videoId) url.searchParams.set('playlist', videoId);
      }
      return url.toString();
    } catch (_) { return null; }
  }
  function control(iframe, method) {
    if (!iframe.getAttribute('src') || !iframe.contentWindow) return;
    iframe.contentWindow.postMessage(JSON.stringify({event:'command',func:method,args:[]}), '*');
  }
  const watcher = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach(({target, isIntersecting, intersectionRatio}) => {
      if (isIntersecting && intersectionRatio >= 0.3) {
        if (!target.getAttribute('src')) {
          const url = videoUrl(target.dataset.blsVideoSrc, target);
          if (!url) return;
          target.setAttribute('allow', (target.getAttribute('allow') || '') + '; autoplay');
          target.setAttribute('loading', 'lazy');
          target.src = url;
        } else {
          control(target, 'playVideo');
        }
      } else {
        control(target, 'pauseVideo');
      }
    });
  }, {threshold:[0,0.3,0.6]}) : null;
  function scan(root) {
    const frames = root.querySelectorAll ? root.querySelectorAll('iframe[data-bls-video-src]') : [];
    frames.forEach((iframe) => {
      if (observed.has(iframe)) return;
      observed.add(iframe);
      if (watcher) watcher.observe(iframe);
      else {
        const url = videoUrl(iframe.dataset.blsVideoSrc, iframe);
        if (url) iframe.src = url;
      }
    });
  }
  scan(document);
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
